// Client-side session cache for address validation
// Ensures consistent session IDs for the same postal code + house number combinations

const sessionCache = new Map<string, string>();

/**
 * Generates a random string of specified length
 */
function generateRandomString(length: number): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

/**
 * Gets or creates a consistent session ID for a postal code + house number combination
 * This ensures the same address query always uses the same session ID for API caching
 */
export function getSessionId(postalCode: string, houseNumber: string): string {
  // Normalize inputs to create consistent cache key
  const normalizedPostalCode = postalCode.toUpperCase().replace(/\s/g, '');
  const normalizedHouseNumber = houseNumber.replace(/\D/g, '');
  const cacheKey = `${normalizedPostalCode}-${normalizedHouseNumber}`;
  
  // Return existing session ID or create new one
  let sessionId = sessionCache.get(cacheKey);
  if (!sessionId) {
    sessionId = generateRandomString(8);
    sessionCache.set(cacheKey, sessionId);
  }
  
  return sessionId;
}

/**
 * Clears the session cache (useful for testing or manual cache clearing)
 */
export function clearSessionCache(): void {
  sessionCache.clear();
}
